import React, { useState } from "react";
import { Link } from "react-router-dom";
import Product from "./Product";

const TrendingProducts = () => {
  const trendingProducts = [
    {
      id: 1,
      image: "/images/product1.jpg",
      category: "Artisanat",
      name: "Nectar au Baobab/Tamarin",
      originalPrice: 78000,
      discount: 75,
      currentPrice: 41500,
      rating: 4.5,
      reviews: 85,
      seller: "Mobidas Sarl",
      isFavorite: false
    },
    {
      id: 2,
      image: "/images/product2.jpg",
      category: "Artisanat",
      name: "Nectar au Baobab",
      originalPrice: 18000,
      discount: 75,
      currentPrice: 14500,
      rating: 4.5,
      reviews: 85,
      seller: "Mobidas Sarl",
      isFavorite: false
    },
    {
      id: 3,
      image: "/images/product3.jpg",
      category: "Artisanat",
      name: "Masque de culture",
      originalPrice: 18000,
      discount: 75,
      currentPrice: 10000,
      rating: 4.5,
      reviews: 85,
      seller: "Mobidas Sarl",
      isFavorite: false
    },
    {
      id: 4,
      image: "/images/product4.jpg",
      category: "Meuble",
      name: "Chaise d'intérieur",
      originalPrice: 200000,
      discount: 25,
      currentPrice: 120500,
      rating: 4.5,
      reviews: 85,
      seller: "Mobidas Sarl",
      isFavorite: false
    },
    {
      id: 5,
      image: "/images/product5.jpg",
      category: "Artisanat",
      name: "Nectar au Baobab/Tamarin",
      originalPrice: 18000,
      discount: 75,
      currentPrice: 1500,
      rating: 4.5,
      reviews: 85,
      seller: "Mobidas Sarl",
      isFavorite: false
    },
    {
      id: 6,
      image: "/images/product6.jpg",
      category: "Artisanat",
      name: "Nectar au Baobab/Tamarin",
      originalPrice: 18000,
      discount: 75,
      currentPrice: 1500,
      rating: 4.5,
      reviews: 85,
      seller: "Mobidas Sarl",
      isFavorite: false
    },
    {
      id: 7,
      image: "/images/product7.jpg",
      category: "Artisanat",
      name: "Nectar au Baobab/Tamarin",
      originalPrice: 18000,
      discount: 75,
      currentPrice: 1500,
      rating: 4.5,
      reviews: 85,
      seller: "Mobidas Sarl",
      isFavorite: false
    },
    {
      id: 8,
      image: "/images/product8.jpg",
      category: "Artisanat",
      name: "Nectar au Baobab/Tamarin",
      originalPrice: 18000,
      discount: 75,
      currentPrice: 1500,
      rating: 4.5,
      reviews: 85,
      seller: "Mobidas Sarl",
      isFavorite: false
    }
  ];

  const [products, setProducts] = useState(trendingProducts);

  const toggleFavorite = (productId) => {
    setProducts(products.map(product => 
      product.id === productId 
        ? { ...product, isFavorite: !product.isFavorite }
        : product
    ));
  };

  const addToCart = (productId) => {
    console.log(`Produit ${productId} ajouté au panier`);
  };

  const renderStars = (rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <svg
          key={i}
          className={`w-4 h-4 ${i <= rating ? 'text-yellow-400' : 'text-gray-300'}`}
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
        </svg>
      );
    }
    return stars;
  };

  return (
    <section className="bg-gray-100 p-4 lg:p-8 rounded-lg">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-bold text-gray-900">Produits tendance</h2>
        <Link
          to="/products"
          className="text-gray-800 hover:text-gray-900 text-sm font-medium flex items-center gap-2 transition-colors"
        >
          Voir plus de produit
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </Link>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {products.map((product) => (
          <Product
            key={product.id}
            product={product}
            onToggleFavorite={toggleFavorite}
            onAddToCart={addToCart}
            renderStars={renderStars}
          />
        ))}
      </div>
    </section>
  );
};

export default TrendingProducts; 